import React from "react";
import "./Hero.scss";

import Button from "../../../components/Button/Button";
import { ReactComponent as GooglePlayIcon } from "../../../assets/svg/googleplay-logo-v2.svg";
import { ReactComponent as AppleIcon } from "../../../assets/svg/apple-logo-v2.svg";

import HeroImg from "../../../assets/png/hero-img.png";
import HeroMobileImg from "../../../assets/png/hero-mobile-img.png";
import ScLogo from "../../../assets/svg/sc-my-logo.svg";
import HeroVid from "../../../assets/vid/tp-vid-hero.mp4";
import HeroPhone from "../../../assets/png/phone-hero-img.png";
import PhoneElem1 from "../../../assets/png/phone-element-img-1.png";
import PhoneElem2 from "../../../assets/png/phone-element-img-2.png";
import PhoneElem3 from "../../../assets/png/phone-element-img-3.png";
import PhoneElem4 from "../../../assets/png/phone-element-img-4.png";

import useWindowSize from "../../../hooks/useWindowResize";

/* ========= Reusable Section ========= */
function HeroButtonGroup({ disabled = false }) {
  return (
    <div className="tp-hero-button-container">
      <div className="tp-hero-button-wrapper">
        <Button
          className={`filled-expand ${disabled ? "disabled" : ""}`}
          icon={GooglePlayIcon}
          // href="https://google.com" (pending for go-live confirmation)
          target="_blank"
          disabled={disabled}
        >
          Coming soon to Android
        </Button>
        <Button
          className={`filled-expand-dark ${disabled ? "disabled" : ""}`}
          icon={AppleIcon}
          // href="https://google.com" (pending for go-live confirmation)
          target="_blank"
          disabled={disabled}
        >
          Coming soon to iOS
        </Button>
      </div>
    </div>
  );
}

/* ========= Page Component ========= */
function Hero() {
  const { width } = useWindowSize();
  const isMobile = width <= 768;

  const heroDesc = `Crypto trading made easy with Ringgit.`;

  const heroInfo = (
    <>
      We are a provisionally registered digital asset exchange (DAX) operator,
      regulated by the Securities Commission Malaysia.
      <span className="learn-more">
        <a
          href="https://www.sc.com.my/regulation/guidelines/recognizedmarkets/list-of-registered-digital-asset-exchanges"
          target="_blank"
        >
          Learn more
        </a>
      </span>
    </>
  );

  return (
    <div className="tp-main-hero">
      {isMobile ? (
        <div className="tp-main-hero-wrapper">
          <div className="left-content-wrapper">
            <p className="tp-hero-title">
              Your Daily
              <span className="gradient">
                Crypto <span>Exchange</span>
              </span>
            </p>

            <div className="tp-hero-mobile-content-wrapper">
              <div className="mobile-image-wrapper">
                <img
                  src={HeroPhone}
                  alt="tp-phone-img"
                  className="mobile-phone-img"
                />
                <img
                  src={PhoneElem1}
                  alt="tp-phone-img"
                  className="mobile-phone-element first"
                />
                <img
                  src={PhoneElem2}
                  alt="tp-phone-img"
                  className="mobile-phone-element second"
                />
                <img
                  src={PhoneElem3}
                  alt="tp-phone-img"
                  className="mobile-phone-element third"
                />
                <img
                  src={PhoneElem4}
                  alt="tp-phone-img"
                  className="mobile-phone-element fourth"
                />
              </div>
              <video
                autoPlay
                playsInline
                loop
                muted
                className="tp-heromobile-vid"
              >
                <source src={HeroVid} type="video/webm" />
                <source src={HeroVid} type="video/mp4" />
              </video>
            </div>

            <p className="tp-hero-desc">{heroDesc}</p>

            <div className="hero-info-wrapper">
              <p className="tp-hero-info">{heroInfo}</p>
              <img src={ScLogo} alt="sc-my-logo" className="sc-my-logo" />
            </div>

            {/* 👇 Reusable button group for mobile */}
            <HeroButtonGroup />
          </div>
        </div>
      ) : (
        <div className="tp-main-hero-wrapper">
          <div className="left-content-wrapper">
            <div className="hero-title-desc-wrapper">
              <p className="tp-hero-title">
                Your Daily <br />
                <span className="gradient">
                  Crypto <span>Exchange</span>
                </span>
              </p>
              <p className="tp-hero-desc">{heroDesc}</p>
            </div>

            <div className="hero-info-wrapper">
              <p className="tp-hero-info">{heroInfo}</p>
              <img src={ScLogo} alt="sc-my-logo" className="sc-my-logo" />
            </div>

            {/* 👇 Reusable button group for desktop */}
            <HeroButtonGroup />
          </div>

          <div className="tp-hero-img-wrapper">
            <div className="phone-section-wrapper">
              <img src={HeroPhone} alt="tp-phone-img" className="phone-img" />
              <img
                src={PhoneElem1}
                alt="tp-phone-img"
                className="phone-element first"
              />
              <img
                src={PhoneElem2}
                alt="tp-phone-img"
                className="phone-element second"
              />
              <img
                src={PhoneElem3}
                alt="tp-phone-img"
                className="phone-element third"
              />
              <img
                src={PhoneElem4}
                alt="tp-phone-img"
                className="phone-element fourth"
              />
            </div>
            <video autoPlay playsInline loop muted className="tp-hero-vid">
              <source src={HeroVid} type="video/webm" />
              <source src={HeroVid} type="video/mp4" />
            </video>
          </div>
        </div>
      )}
    </div>
  );
}

export default Hero;
